export const SET = 'companies/SET';



// WEBPACK FOOTER //
// ./app/routes/company/store/action-types.js